import { render, staticRenderFns } from "./OrderModalComponent.vue?vue&type=template&id=d8dee2d2&scoped=true&"
import script from "./OrderModalComponent.vue?vue&type=script&lang=js&"
export * from "./OrderModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./OrderModalComponent.vue?vue&type=style&index=0&id=d8dee2d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8dee2d2",
  null
  
)

export default component.exports